export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11468.7b597885.jpg";